import * as Ariakit from '@ariakit/react'
import { ForwardedRef, forwardRef } from 'react'

function DropdownSeparatorComponent(props: Ariakit.MenuSeparatorProps<'hr'>, ref: ForwardedRef<HTMLHRElement>) {
  return <Ariakit.MenuSeparator ref={ref} {...props} className="my-1 opacity-30" />
}

export const DropdownSeparator = forwardRef(DropdownSeparatorComponent) as (props: {
  ref?: Ariakit.MenuSeparatorProps<'hr'> & ForwardedRef<HTMLHRElement>
}) => ReturnType<typeof DropdownSeparatorComponent>
